@if (uploadState === mFileUploadState.idle) {
  <div
    (click)="file.click()"
    (drop)="onFileDrop($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    class="flex flex-col border-dashed border-blue-300 border-2 cursor-pointer bg-blue-100 justify-center text-center gap-3 rounded-lg m-drop-file p-4 {{
      customStyle
    }}">
    <span class="material-symbols-outlined text-blue-300 icon-extra-large">
      upload_file
    </span>
    <span class="text-blue-600 b2"
      >Drop a {{ fileType }} data file here, <br />or click to select one.</span
    >
    <input
      id="inputFile"
      type="file"
      accept="text/csv"
      #file
      name="uploadFile"
      [hidden]="true"
      (change)="onFileSelected($event)" />
  </div>
}
@if (uploadState === mFileUploadState.uploading) {
  <div
    class="flex flex-col border-dashed border-blue-300 border-2 bg-blue-100 justify-center text-center gap-2 rounded-lg m-drop-file {{
      customStyle
    }}">
    <span class="material-symbols-outlined text-blue-300"> description </span>
    <span class="c3">{{ selectedFile?.name }}</span>
    <span class="c2">
      Verifying your file...<br />Please wait and do not close this popup.
    </span>
    <p-progressBar
      class="mx-4 bg-blue-600"
      [value]="progress"
      pTooltip="{{ progress }}%"
      tooltipPosition="top"
      [showValue]="false"></p-progressBar>
  </div>
}
@if (uploadState === mFileUploadState.uploaded) {
  <div
    class="flex flex-col border-dashed border-green-300 border-2 bg-green-100 justify-center text-center gap-2 rounded-lg m-drop-file {{
      customStyle
    }}">
    <span class="material-symbols-outlined text-green-700"> check_circle </span>
    <span class="c3">{{ selectedFile?.name }}</span>
    <span class="c2">
      The file has been verified.<br />Please click the
      {{ uploadButtonText }} button to proceed.
    </span>
    <p-progressBar
      class="mx-4"
      [styleClass]="styleClass"
      [value]="progress"
      pTooltip="{{ progress }}%"
      tooltipPosition="top"
      [showValue]="false"></p-progressBar>
  </div>
}
@if (uploadState === mFileUploadState.error) {
  <div
    class="flex flex-col border-dashed border-red-300 border-2 bg-red-100 justify-center text-center gap-2 rounded-lg m-drop-file {{
      customStyle
    }}">
    <span class="material-symbols-outlined text-red-700"> warning </span>
    <span class="c3">{{ selectedFile?.name }}</span>
    <span class="c2"> File upload error:<br />{{ errorMessage }} </span>
    <p-progressBar
      class="mx-4"
      [styleClass]="styleClass"
      [value]="progress"
      [showValue]="false"></p-progressBar>
  </div>
}
